"use client";

import { useEffect } from "react";
import { track } from "@/lib/analytics";
import { EVENEMENT } from "@/lib/evenements";

/**
 * Compte l'ouverture d'une page corridor.
 *
 * Un composant à part, sans rendu, plutôt qu'un `track()` dans la page :
 * la page corridor est générée à l'avance (`generateStaticParams`) et doit
 * le rester pour le référencement. Lui coller `"use client"` la ferait
 * basculer côté client et lui coûterait sa raison d'exister.
 */
export function MesureCorridor({ corridor }: { corridor: string }) {
  useEffect(() => {
    track(EVENEMENT.CORRIDOR_VU, { corridor });
  }, [corridor]);

  return null;
}
